// Tipos/labels para o acompanhamento em tempo real das solicitações de leilão
// que ainda vivem no Redis — antes de virarem PropostaLeilao no Postgres.
// Espelha `ListSolicitacaoRedisResponseDto` do backend `consignado-trabalhador`.

export enum RedisSolicitacaoStatus {
  WAITING_BID = "AGUARDANDO_LANCE",
  BID_SENT = "LANCE_ENVIADO",
  WON = "LANCE_VENCIDO",
  REPROVED = "LEILAO_PERDIDO",
  SENT_TO_DATAPREV = "ENVIADO_DATAPREV",
  INCLUDED_DATAPREV = "INCLUIDO_DATAPREV",
}

export const REDIS_SOLICITACAO_STATUSES: RedisSolicitacaoStatus[] = [
  RedisSolicitacaoStatus.WAITING_BID,
  RedisSolicitacaoStatus.BID_SENT,
  RedisSolicitacaoStatus.WON,
  RedisSolicitacaoStatus.REPROVED,
  RedisSolicitacaoStatus.SENT_TO_DATAPREV,
  RedisSolicitacaoStatus.INCLUDED_DATAPREV,
];

export const REDIS_STATUS_LABELS: Record<RedisSolicitacaoStatus, string> = {
  [RedisSolicitacaoStatus.WAITING_BID]: "Aguardando lance",
  [RedisSolicitacaoStatus.BID_SENT]: "Lance enviado",
  [RedisSolicitacaoStatus.WON]: "Vencido no leilão",
  [RedisSolicitacaoStatus.REPROVED]: "Leilão perdido",
  [RedisSolicitacaoStatus.SENT_TO_DATAPREV]: "Enviado ao Dataprev",
  [RedisSolicitacaoStatus.INCLUDED_DATAPREV]: "Incluído no Dataprev",
};

export const REDIS_STATUS_COLORS: Record<RedisSolicitacaoStatus, string> = {
  [RedisSolicitacaoStatus.WAITING_BID]: "yellow",
  [RedisSolicitacaoStatus.BID_SENT]: "blue",
  [RedisSolicitacaoStatus.WON]: "green",
  [RedisSolicitacaoStatus.REPROVED]: "red",
  [RedisSolicitacaoStatus.SENT_TO_DATAPREV]: "purple",
  [RedisSolicitacaoStatus.INCLUDED_DATAPREV]: "teal",
};

export interface RedisSolicitacaoLance {
  codigoLanceLeilao: string;
  taxaDeJurosMensal: number;
  valorLiberado: number;
  numeroParcelas: number;
  posicao: number;
  dataHoraInclusao: string;
}

export interface RedisSolicitacaoItem {
  codigoLote: string;
  numeroSolicitacao: number;
  cpf: string;
  matricula: string;
  inscricaoEmpregadorCodigo: number;
  inscricaoEmpregadorDescricao: string;
  numeroInscricaoEmpregador: string;
  valorLiberado: number;
  nroParcelas: number;
  dataHoraValidadeSolicitacao: string;
  nomeTrabalhador: string;
  dataNascimento: string;
  margemDisponivel: number;
  elegivelEmprestimo: boolean;
  pessoaExpostaPoliticamenteCodigo: number;
  pessoaExpostaPoliticamenteDescricao: string;
  dataAdmissao: string;
  alertas: unknown[];
  status: RedisSolicitacaoStatus;
  id?: string;
  codigoSolicitacaoLeilao?: string;
  codigoRequisicao?: string;
  valorTaxaMensal?: number;
  processorId?: string;
  dataHoraInicioLeilao?: string;
  dataHoraFimLeilao?: string;
  lance: RedisSolicitacaoLance | null;
  criadoEm: string;
  atualizadoEm: string;
}

// Resposta paginada (snake_case espelha o wire do backend).
export interface RedisSolicitacaoListResponse {
  data: RedisSolicitacaoItem[];
  total: number;
  pagina_atual: number;
  tamanho_pagina: number;
  total_paginas: number;
  pagina_anterior: number | null;
  proxima_pagina: number | null;
}

export interface RedisSolicitacaoListParams {
  page: number;
  pageSize: number;
  searchTerm?: string;
  statuses?: RedisSolicitacaoStatus[];
  codigoLote?: string;
}

export interface RedisSolicitacaoFilters {
  searchTerm: string;
  statuses: RedisSolicitacaoStatus[];
  codigoLote: string;
}

export const INITIAL_REDIS_FILTERS: RedisSolicitacaoFilters = {
  searchTerm: "",
  statuses: [],
  codigoLote: "",
};
